const tableFields = {
  columns: [
    {
      title: '#',
      type: 'index',
      width: 40,
      align: 'center'
    },
    {
      key: 'name',
      title: 'Name'
    },
    {
      key: 'chinese_name',
      title: 'Chinese name'
    },
    {
      key: 'specification',
      title: 'Specification'
    },
    {
      title: 'Part number',
      key: 'part_identity',
      width: 100,
      render: (h, params) => {
        return h('span', params.row.part_identity?.part_number)
      }
    },
    {
      key: 'description',
      title: 'Description',
      minWidth: 300
    }
  ]
}

export default tableFields
